import { BlueBox } from './styles';

export default BlueBox;
